import { PunchlistItem } from "../../components/Messages/PunchListModels";

export enum SearchPuchlistOrder
{
    RLEConsent,
    LoadPatientIntoRLE,
    CachedDocumentCheck,
    SearchPatientMatch,
    GetDocumentList
}

export const surescriptsApiCallTime = 
{
    patientSearchInSeconds: 15,
    getDocumentList: 180
}

export const orderTitles: PunchlistItem<SearchPuchlistOrder>[] = [
    { order: SearchPuchlistOrder.RLEConsent, 
        titles: { 
            todo: "Patient Consent", 
            processing: "Loading Surescripts MPI consent...", 
            complete: "Patient opted into Surescripts MPI", 
            error: "Patient opted out of Surescripts MPI" 
        }
    },
    { order: SearchPuchlistOrder.LoadPatientIntoRLE, 
        titles: { 
            todo: "MPI Sync Status", 
            processing: "Loading patient into MPI...", 
            complete: "Patient successfully loaded to MPI", 
            error: "Unable to sync with Surescripts MPI" 
        },
        subTitles: {
            processing: "Sending patient demographics to Surescripts"
        }
    },
    { order:  SearchPuchlistOrder.CachedDocumentCheck,
        titles:{
            todo: "Existing Document Check",
            processing: "Checking for cached documents...",
            complete: "Checked for cached documents",
            error: "Problem trying to check for existing documents"
        }
    },
    { order: SearchPuchlistOrder.SearchPatientMatch, 
        titles: { 
            todo: "Patient Search", 
            processing: "Locating patient within Surescripts RLE...", 
            complete: "Patient Located", 
            error: "Surescripts RLE could not find this patient" 
        },
        subTitles: {
            processing: `Searching for patient in Surescripts. This will normally take up to ${surescriptsApiCallTime.patientSearchInSeconds} seconds.`
        }
    },
    { order: SearchPuchlistOrder.GetDocumentList,  
        titles: { 
            todo: "Document Search", 
            processing: "Retrieving document list...", 
            complete: "Patient Documents List Returned", 
            error: "Unable to load document list" 
        },
        subTitles: {
            processing: `Getting patient documents list from Surescripts. This will normally take up to ${surescriptsApiCallTime.getDocumentList} seconds.`
        }
    },
];

